import React from 'react';
import ReactDOM from "react-dom";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, TabContent, TabPane, Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { HelpTextPopup } from './../HelpTextPopup/index';
import CommonSqFtInfoPopup from '../CommonSqFtInfoPopup/CommonSqFtInfoPopup';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableRow from '@material-ui/core/TableRow';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import './CompOverview.css';
import axios from 'axios';
import { CONFIG } from '../../utils/config';
import { MissingCompetitor } from '../MissingCompetitor';
import { MarketProfile } from '../MarketProfile';
import { CompetitorStore } from '../CompetitorStore';
import noImage from './../../Assets/Images/no-image.jpg';
import NumberFormat from 'react-number-format';
import LocationOn from '@material-ui/icons/LocationOn';
import { StoreStreetView } from '../StoreStreetView';
import homeIcon from './../../Assets/Images/home-icon-circle.png';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import InfiniteScroll from 'react-infinite-scroller';
import MapGL, { Layer, NavigationControl, Popup, Source, Marker, WebMercatorViewport, FlyToInterpolator } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const params = { v: '3.exp', key: CONFIG.GoogleMapsApiKey };

const layerStyle = {
  id: "point",
  type: "circle",
  paint: {
    "circle-radius": 5,
    "circle-color": ["get", "colorCode"],
  },
};

export class InfoWindowEx extends React.Component {
  constructor(props) {
    super(props);
    this.onInfoWindowOpen = this.onInfoWindowOpen.bind(this);
    if (!this.containerElement) {
      this.containerElement = document.createElement(`div`);
    }
  }

  onInfoWindowOpen() {
    ReactDOM.render(
      React.Children.only(this.props.children),
      this.containerElement
    );
    this.infoWindowRef.current.infowindow.setContent(this.containerElement);
  }
}

export default class CompOverview extends React.Component {

  constructor(props) {
    super(props);
    this.MarketProfile = React.createRef();
    this.infoWindowRef = React.createRef();
    this.toggle = this.toggle.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    //this.tabsChange = this.toggle.bind(this);
    this.child = React.createRef();
    this.compstorechild = React.createRef();
    this.storeImageStreetView = React.createRef();
    this.myRef = React.createRef()
    this.state = {
      dropdownOpen: false,
      showingInfoWindow: false,
      compOverviewData: [],
      storeData: [],
      activeMarker: {},
      locationInfoData: [],
      isLoading: false,
      activeTab: '1',
      dropDownValue: "Sort by",
      sortByOrder: '1',
      isPdfLoading: false,
      centerPoint: [],
      snackOpen: false,
      snackMSg: '',
      snackClr: '',
      zoomValue: 6,
      hisData: false,
      compCount: 0,
      hasMoreData: false,
      pageStart: 1,
      mapData: [],
      unitData: [],
      viewport: {
        width: "100%",
        height: "100vh",
        longitude: 0,
        latitude: 0,
        zoom: 10,
      },
      popupInfoLatlng: {},
      totalSqFtFlag: false,
      homeLatLng: { longitude: 0, latitude: 0 },
      satelliteView: 0
    };

    this.mapRef = React.createRef();
    this.getParams = this.getParams.bind(this);
    this.getParams1 = this.getParams1.bind(this);
    this.addDefaultSrcMap = this.addDefaultSrcMap.bind(this);
  }

  getParams(name, sid) {
    this.child.current.toggleModal(name, sid);
  }

  getStoreStreeView(lat, lon, name) {
    this.storeImageStreetView.current.toggleStoreModal(lat, lon, name);
  }

  onMapCreated(map) {
    map.setOptions({
      disableDefaultUI: true,
      mapTypeControl: true
      // defaultOptions={  zoomControl: true,fullscreenControl: false,streetViewControl: false, disableDefaultUI: false, mapTypeControl: true, }}
    });
  }

  tabsChange(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  NumberFormat(number) {
    return new Intl.NumberFormat().format(number);
  }

  onMarkerClick = (event) => {
    let unitData = this.state.unitData;
    let cCode = this.state.locationInfoData.countryCode;
    let Authorize = localStorage.getItem('accessKey');//this.props.Authorize;
    let latitude = Number(event.lngLat[1]);
    let longitude = Number(event.lngLat[0]);
    let eventData = event.features.filter(ft => ft.layer.type === "circle")[0];
    if (Authorize) {
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + Authorize;
    }
    if (eventData && eventData.layer.type === "circle") {
      let selectedMarker = eventData.properties;
      let storeId = selectedMarker.storeID;
      const data = {
        UserStoreId: parseInt(this.props.match.params.userstoreid),
        RegionId: CONFIG.RegionId,
        StoreID: storeId
      }
      axios.post(CONFIG.API_URL + 'dashboard/compsoverviewdatapointdetails', data)
        .then(response => {
          if (response.data.data !== null) {
            const pinPoints = response.data.data;
            let unitTypes = [];
            unitData.map(unit => {
              if (unit.storeID === storeId && unit.value === 1) {
                unitTypes.push(unit.unitType);
              }
            })
            var units = unitTypes.join(", ");
            var address = pinPoints.storeAddress != null ? pinPoints.storeAddress : '';
            var last = address != '' ? address.lastIndexOf(",") : 0;
            var s1 = address != '' ? address.substring(0, last) : '';
            var s2 = address != '' ? address.substring(last + 1) : '';
            var image = pinPoints.storeImagePath != null && pinPoints.storeImagePath != '' ? pinPoints.storeImagePath : noImage;
            let meashotName = (cCode === "DE" || cCode === "AT" || cCode === "CH") ? "sqm" : CONFIG.MeasurementShortName;
            this.setState({
              storeId: storeId,
              strImageMap: image,
              activeMarker: pinPoints.storeName,
              storeName: pinPoints.storeName,
              lat: pinPoints.latitude,
              lng: pinPoints.longitude,
              address: address != null ? s1 : '',
              address1: address != null ? s2 : '',
              //squareFootage: pinPoints.squareFootage === "0" ? "N/A" : this.NumberFormat(pinPoints.squareFootage) + " " + CONFIG.MeasurementShortName,
              squareFootage: pinPoints.squareFootage === "0" ? "N/A" : this.NumberFormat(pinPoints.squareFootage) + " " + meashotName,
              opened: pinPoints.opened === "0" ? "N/A" : pinPoints.opened,
              ownedBy: pinPoints.ownedBy,
              operatedBy: pinPoints.operatedBy,
              priceChangesPercent: pinPoints.priceChangesPercent == null ? "N/A" : pinPoints.priceChangesPercent + "% (Last 30 days)",
              imagePath: image,
              unitsOffered: unitTypes.length > 0 ? units : 'N/A',
              showingInfoWindow: true,
              popupInfoLatlng: { latitude, longitude },
              totalSqFtFlag: pinPoints.sqFtFlag !== 2 ? false : true
            });
          }
        })
        .catch(err => {
          if (err.response.status === 400) {
            if (err.response.data.Message === "Authentication failed") {
              const { from } = this.props.location.state || { from: { pathname: "/UnauthorizedAccess" } };
              this.props.history.push(from);
            }
          }
          else {
          }
        });
    }
  };

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  onMarkerClose = () => {
    this.setState({ showingInfoWindow: false });
  }

  handleClickOpen(e, name) {
    let sortByOrder = name === "Proximity" ? 1 : name === "Store Name" ? 2 : name === "Total Square Footage" ? 3 : name === "Year Built" ? 4 : '';
    if (name === "Proximity") {//descending order--to Address origin of Market
      this.setState(storeData => {
        this.state.storeData.sort((a, b) => (a.proximity - b.proximity))
      });
    } else if (name === "Year Built") {//descending order--most recent first
      this.setState(storeData => {
        this.state.storeData.sort((a, b) => (b.opened - a.opened))
      });
    } else if (name === "Total Square Footage") {//descending order--high to low
      this.setState(storeData => {
        this.state.storeData.sort((a, b) => (b.squareFootage - a.squareFootage))
      });
    } else if (name === "Store Name") {//ascending order
      this.setState(storeData => {
        this.state.storeData.sort((a, b) => a.storeName !== b.storeName ? a.storeName < b.storeName ? -1 : 1 : 0);
      });
    }
    this.setState({
      dropDownValue: e.currentTarget.textContent, sortByOrder: sortByOrder
    })
  }

  loadDashBoard() {
    let token = localStorage.getItem('accessKey');
    const data = {
      "UserStoreID": parseInt(this.props.match.params.userstoreid),
      "RegionId": CONFIG.RegionId
    }
    if (token) {
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
    }
    axios.post(CONFIG.API_URL + 'dashboard/dashboardlocation', data)
      .then(response => {
        // let zoomValue;
        const locationInfoData = response.data.data.storeDashboard;
        // const centerPoint = response.data.data.centerPointDetail;
        // if (locationInfoData.searchType === 3) {
        //   zoomValue = 10;
        // } else if (locationInfoData.searchType === 2) {
        //   let zCnt = locationInfoData.storeZoneCoverage != "" && locationInfoData.storeZoneCoverage != null ? (locationInfoData.storeZoneCoverage.split(",").length - 1) : 1;
        //   zoomValue = (zCnt > 1) ? 9 : (zCnt > 0) ? 10 : 12;
        // } else if (locationInfoData.searchType === 1) {
        //   let storeZoneCoverage = locationInfoData.storeZoneCoverage.split(' ');
        //   zoomValue = (storeZoneCoverage[0] === '1' || storeZoneCoverage[0] === '2' || storeZoneCoverage[0] === '3') ? 13 : (storeZoneCoverage[0] === '4' || storeZoneCoverage[0] === '5' || storeZoneCoverage[0] === '6') ? 12 : (storeZoneCoverage[0] === '6' || storeZoneCoverage[0] === '7') ? 11 : (storeZoneCoverage[0] === '8' || storeZoneCoverage[0] === '9' || storeZoneCoverage[0] === '10') ? 10 : 6;
        // }
        // let lgt = (centerPoint && (centerPoint.length > 0 && centerPoint[0].longitude != null) ? parseFloat(centerPoint[0].longitude) : parseFloat(locationInfoData.longitude));
        // let ltd = (centerPoint && (centerPoint.length > 0 && centerPoint[0].latitude != null) ? parseFloat(centerPoint[0].latitude) : parseFloat(locationInfoData.latitude));
        let lgt = parseFloat(locationInfoData.longitude);
        let ltd = parseFloat(locationInfoData.latitude);
        this.setState(prevState => ({
          locationInfoData: locationInfoData,
          viewport: {
            ...prevState.viewport,
            longitude: lgt,
            latitude: ltd,
            // zoom: zoomValue
          },
          homeLatLng: { longitude: lgt, latitude: ltd }
        }), () => this.loadMapData());
      }).catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem('accessKey');
          const { from } = this.props.location.state || { from: { pathname: "/" } };
          this.props.history.push(from);
        }
        else if (err.response.status === 403) {
          const { from } = this.props.location.state || { from: { pathname: "/UnauthorizedAccess" } };
          this.props.history.push(from);
        }
        else {
          alert(err.response.data);
        }
      });
  }

  getBoundingValues = (points) => {
    if (points.length) {
      const paddingLength = window.innerHeight / 3;
      const applyToArray = (func, array) => func.apply(Math, array);
      const pointsLong = points.map((point) => point.geometry.coordinates[0]);
      const pointsLat = points.map((point) => point.geometry.coordinates[1]);
      if (!pointsLong.includes(this.state.homeLatLng.longitude)) pointsLong.push(this.state.homeLatLng.longitude);
      if (!pointsLat.includes(this.state.homeLatLng.latitude)) pointsLat.push(this.state.homeLatLng.latitude);
      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)],
      ];
      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(cornersLongLat, {
        padding: { top: paddingLength, bottom: paddingLength, left: paddingLength, right: paddingLength },
      });
      const { longitude, latitude, zoom } = viewport;
      this.setState(prevState => {
        return {
          viewport: {
            ...prevState.viewport,
            latitude: latitude,
            longitude: longitude,
            zoom: zoom,
            transitionDuration: 100,
            transitionInterpolator: new FlyToInterpolator(),
          }
        }
      });
    }
  };

  compOverview() {
    const data = {
      "UserStoreID": parseInt(this.props.match.params.userstoreid),
      "RegionId": CONFIG.RegionId
    }
    let token = localStorage.getItem('accessKey');
    if (token) {
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
    }
    axios.post(CONFIG.API_URL + 'dashboard/compsoverviewdata', data)
      .then(res => {
        const compOverviewData = res.data.data;
        const storeData = compOverviewData.storeData;
        this.setState({ compOverviewData: compOverviewData, storeData: storeData, isLoading: false });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        if (err.response.status === 401) {
          localStorage.removeItem('accessKey');
          const { from } = this.props.location.state || { from: { pathname: "/" } };
          this.props.history.push(from);
        }
        else if (err.response.status === 403) {
          const { from } = this.props.location.state || { from: { pathname: "/UnauthorizedAccess" } };
          this.props.history.push(from);
        }
        else if (err.response.status === 400) {
          alert(err.response.data.Message);
        }
        else {
          alert(err.response.data);
        }
      });
  }

  addDefaultSrc(ev) {
    if (ev.target.src != null) {
      var imageName = require('./../../Assets/Images/no-image.jpg');
      ev.target.src = imageName;
      ev.target.className = "noimages Unit-Store-Img";
    }
  }

  addDefaultSrcMap(ev) {
    if (ev.target.src != null) {
      var imageName = require('./../../Assets/Images/no-image.jpg');
      ev.target.src = imageName;
      this.setState({ imagePath: noImage });
    }
  }

  componentDidMount() {
    // this.setState({ isLoading: true });
    this.loadDashBoard();
    //this.compOverview();
    this.loadStoreList();
  }

  getParams1(storeAddress) {
    let storeId = parseInt(this.props.match.params.userstoreid);
    this.compstorechild.current.toggleStoreModal(storeAddress, storeId);
  }
  downLoadPDF() {
    this.setState({
      // isLoading: true,
      isPdfLoading: false
    });
    var currentDate = moment(new Date()).format("DD-MMM-YYYY");
    let pta = this.state.sortByOrder;
    let usId = parseInt(this.props.match.params.userstoreid);
    let accessKey = localStorage.getItem('SecretKey');
    var timestamp = new Date().getDate() + "" + new Date().getMonth() + "" + new Date().getFullYear() + "" + new Date().getTime();
    //construct filename for pdf report.
    var fileName = usId + "CompOverView" + "_" + timestamp + ".pdf";
    var stoName = this.state.locationInfoData && this.state.locationInfoData.storeName !== null && this.state.locationInfoData.storeName !== '' && this.state.locationInfoData.storeName !== undefined ? this.state.locationInfoData.storeName : 'Your Store';
    var fileNamePdf = stoName + '_' + "Competitor-Overview" + '_' + currentDate + ".pdf";
    this.setState({ snackClr: 'snack-info', snackOpen: true, snackMSg: 'Your download is being processed. The ' + fileNamePdf + ' file will download automatically to your browser when ready and Please do not close or reload the pages until download completes. We recommend you check your Downloads folder if you don’t see it in your browser.' });
    let ComponentName = 2;
    const Input = {
      "RegionID": CONFIG.RegionId,
      "URL": CONFIG.OPTZ_URL + "render-pdf/" + accessKey + '/' + ComponentName + '/0/' + usId + '/' + pta + "/",
      "FileName": fileName,
    }
    // axios.post(CONFIG.API_URL + 'dashboard/generatepdfbypage', Input)
    axios(
      {
        url: CONFIG.API_URL + 'dashboard/generatepdfbypage',
        method: 'post',
        responseType: 'blob',
        data: Input
      })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileNamePdf;
        link.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(link.href);
          link.remove();
        }, 3000);
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      })
  }
  snackHandleclose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackOpen: false });
  };

  historicModal = (name, id) => {
    this.child.current.compModal(name, id);
  }

  //historical data modal popup
  historicalModalOpen() {
    this.setState(state => ({ hisData: !state.hisData }));
  }
  // close historicall modal 
  cancelHisData = () => this.setState(state => ({ hisData: !state.hisData }))

  //loading all storelist using lazyload
  loadLazzyData() {
    let page = this.state.pageStart;
    let countCheck = (this.state.compCount / 10).toString();
    let pageCount = this.state.compCount / 10;
    let storeCount = countCheck.indexOf('.') != -1 ? parseInt(pageCount) + 1 : pageCount;
    if (page <= storeCount) {
      let Authorize = localStorage.getItem('accessKey');//this.props.Authorize;
      if (Authorize) {
        axios.defaults.headers.common["Authorization"] = 'Bearer ' + Authorize;
      }
      const data = {
        "UserStoreID": parseInt(this.props.match.params.userstoreid),
        "RegionId": CONFIG.RegionId,
        "PageNo": page
      }

      axios.post(CONFIG.API_URL + 'dashboard/compsoverviewdata', data)
        .then(response => {
          let prevStoreData = [...this.state.storeData];
          let newStoreData = prevStoreData.concat(response.data.data.storeData);
          let prevUnitData = [...this.state.unitData];
          let newUnitData = prevUnitData.concat(response.data.data.unitData);
          this.setState({ storeData: newStoreData, unitData: newUnitData, pageStart: page + 1 }, () => {
            this.loadLazzyData();
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            localStorage.removeItem('accessKey');
            const { from } = this.props.location.state || { from: { pathname: "/" } };
            this.props.history.push(from);
          }
          else if (err.response.status === 403) {
            const { from } = this.props.location.state || { from: { pathname: "/UnauthorizedAccess" } };
            this.props.history.push(from);
          }
          else if (err.response.status === 400) {
            alert(err.response.data.Message);
          }
          else {
            alert(err.response.data);
          }
        });
    } else {
      this.setState({ hasMoreData: false });
    }
  }

  //All Store List
  loadStoreList() {
    this.setState({ isLoading: true });
    const data = {
      "UserStoreID": parseInt(this.props.match.params.userstoreid),
      "RegionId": CONFIG.RegionId,
      "PageNo": this.state.pageStart
    }
    let Authorize = localStorage.getItem('accessKey');//this.props.Authorize;
    if (Authorize) {
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + Authorize;
    }

    axios.post(CONFIG.API_URL + 'dashboard/compsoverviewdata', data)
      .then(response => {
        let compOverviewData = response.data.data;
        let unitData = response.data.data.unitData;
        let storeData = response.data.data.storeData;
        let compCount = response.data.data.overViewInfo.compsCount;
        this.setState({ unitData, compOverviewData, storeData, isLoading: false, compCount, hasMoreData: true, pageStart: 2 }, () => {
          this.loadLazzyData();
        });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        if (err.response.status === 401) {
          localStorage.removeItem('accessKey');
          const { from } = this.props.location.state || { from: { pathname: "/" } };
          this.props.history.push(from);
        }
        else if (err.response.status === 403) {
          const { from } = this.props.location.state || { from: { pathname: "/UnauthorizedAccess" } };
          this.props.history.push(from);
        }
        else if (err.response.status === 400) {
          alert(err.response.data.Message);
        }
        else {
          alert(err.response.data);
        }
      });
  }

  //load map pinpoints
  loadMapData() {
    const data = {
      "UserStoreID": parseInt(this.props.match.params.userstoreid),
      "RegionId": CONFIG.RegionId,
      "IsMapBox": CONFIG.IsMapbox,
    }
    let token = localStorage.getItem('accessKey');
    if (token) {
      axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
    }
    axios.post(CONFIG.API_URL + 'dashboard/compsoverviewdatapoint', data)
      .then(res => {
        const mapData = res.data.data;
        this.setState({ mapData }, () => this.getBoundingValues(mapData));
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        if (err.response.status === 401) {
          localStorage.removeItem('accessKey');
          const { from } = this.props.location.state || { from: { pathname: "/" } };
          this.props.history.push(from);
        }
        else if (err.response.status === 403) {
          const { from } = this.props.location.state || { from: { pathname: "/UnauthorizedAccess" } };
          this.props.history.push(from);
        }
        else if (err.response.status === 400) {
          alert(err.response.data.Message);
        }
        else {
          alert(err.response.data);
        }
      });
  }

  handleViewportChange = (viewport) => {
    this.setState({ viewport });
  }

  onLoadHomeMarker = () => {
    setTimeout(() => {
      let mapbox = this.mapRef.current.getMap();
      mapbox.loadImage(homeIcon, (error, image) => {
        if (image) mapbox.addImage('homeMarker', image)
        else if (error) throw error;
      });
    }, 500);
  }

  changeMapView = (type) => {
    this.setState({ satelliteView: type }, () => this.onLoadHomeMarker());
  }

  render() {
    document.title = 'StorTrack: Self-storage market pricing data';
    const { locationInfoData, isLoading, strImageMap, pageCount, sortByOrder, isPdfLoading, snackOpen, snackMSg } = this.state;
    const { compOverviewData, storeData, hisData, hasMoreData, mapData, unitData, viewport, popupInfoLatlng, totalSqFtFlag, homeLatLng, satelliteView } = this.state;
    // const infoWindowContent = '<table class="map-table" style="width: 100%;">' + '<tr><td width="70%"><b>' + this.state.storeName + '</b><p> ' + this.state.address + ',<br/>' + this.state.address1 + '</p></td><td width="30%" style="text-align: center;"><img class="Unit-Store-Img" style="float: none;" src=' + this.state.imagePath + ' /></td></tr></table><table><tr>' + '<td class="label-list">' + ((this.state.locationInfoData.countryCode === "DE" || this.state.locationInfoData.countryCode === "AT" || this.state.locationInfoData.countryCode === "CH") ? "Total Square Metre" : CONFIG.MeasurementLabel) + '</td>' + '<td>' + this.state.squareFootage + '</td></tr>' + '' + '<tr>' + '<td class="label-list">Opened</td>' + '<td>' + this.state.opened + '</td></tr>' + '<tr>' + '<td class="label-list">Owned by</td>' + '<td>' + this.state.ownedBy + '</td></tr>' + '<tr>' + '<td class="label-list">Operated by</td>' + '<td>' + this.state.operatedBy + '</td></tr>' + '<tr>' + '<td class="label-list">Price Volatility</td>' + '<td>' + this.state.priceChangesPercent + '</td>' + '</tr>' + '<td class="label-list">Units Offered</td>' + '<td style="width: 150px; line-height: 18px;">' + this.state.unitsOffered + '</td>' + '</tr>' + '</table>';
    const defaultProps = {
      helpTitle: "Competitor Overview",
      helpContent: "<p>Learn more about the stores in this Market. What are they advertising? Are they pricing aggressively? How big is their facility? etc.</p><h6>Store Types</h6><p>At the top of the page you will find a breakdown of the types of stores in this Market</p><h6>Real Estate Investment Trust (REIT) Stores</h6><p>Any stores operated by the following companies:</p><ul style='padding-left: 30px;list-style: disc;'><li>Public Storage</li><li>Extra Space</li><li>LifeStorage</li><li>Cubesmart</li><li>National Storage Affiliates</li><li>Global Self Storage</li></ul><h6>Multi Store Operators (Multi-Ops)</h6><p>Companies operating more than 2 stores</p><h6>Single Store Operators (Single-Ops)</h6><p>Companies (typically independent operators) managing a single store</p><h6>Competitor Overview</h6><ul><li>This grid below shows each store in this Market. Each store 'snapshot' shows the store name, address and proximity to your store. Further, it includes the building's square footage (derived from public sources or in some instances from calculations made by StorTrack's data science team).</li><li>You will also find ownership and management information and store age.</li></ul><h6>How aggressive is this store/competitor?</h6><ul><li>Pricing volatility is a major indicator of how aggressive or passive a store or Market is with their pricing. A store which frequently raises or lowers their rates, will typically have a higher pricing volatility. Here you can view the pricing volatility for a store over the last 30 days.</li><li>Pricing Volatility is calculated by taking the number of times a pricing change occurred over the last 30 days for that store.</li></ul><h6>Unit Availability</h6><ul><li>For each store we show 11 of the most common unit types. This is meant to give you a quick snapshot of the unit types each store in this Market is advertising.</li><li>The green checkmark means this unit type is currently advertised by this store </li><li>The red x means this store has not advertised this unit type in the last 12 months</li><li>The grey icon means this store has advertised this unit type in the last 12 months, but it is not currently advertising it</li></ul><h6>Street View</h6><p>Hover over the store's image to view a Google Map snapshot of this facility</p><h6>Map View of Stores</h6><p>Click on the map pin point icon on the upper right corner to view a map of all the stores in your Market</p><p>Refer the below help video for more information.</p><iframe width='472' height='248' src='https://www.youtube.com/embed/sx215ZiJ0tM' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
    }

    return (
      <div className="wrapper my-account-box competitor-overview">
        <MarketProfile ref={this.child} />
        {isLoading ? <div className="loader-wrap"><div className="loading"></div></div> : ''}
        <div style={{ display: 'none' }}><img className="Unit-Store-Img" src={strImageMap} alt="No Image" onError={this.addDefaultSrcMap} /></div>
        <Breadcrumbs separator="›" aria-label="Breadcrumb" className="breadcrumb-float-left breadcrumb-top">


          {localStorage.getItem('isMVP_User') === "false" ? <Link to={{ pathname: `/my-market/` }}>My Markets</Link> : ""}

          <Link to={{ pathname: `/market-dashboard/${this.props.match.params.userstoreid}` }} color="inherit" >Go to Market Dashboard</Link>

          <Typography component="h6" variant="headline" className="link-tag">Competitor Overview</Typography>
        </Breadcrumbs>

        {/* <Link to={"/market-level-data/competitor-overviews/"+this.props.match.params.userstoreid+"/"+sortByOrder+"?"} color="inherit" className="link-tag">Download Pdf</Link> */}
        <Button disabled={!isLoading && compOverviewData && storeData.length != 0 ? false : true} className={compOverviewData && storeData.length != 0 ? "mb-2 apply-btn download-pdf " : "mb-2 download-pdf-disabled"} onClick={this.downLoadPDF.bind(this)}>
          <FontAwesomeIcon icon={faFilePdf} />
          PDF Download
        </Button>

        <div className="clearfix"> </div>
        <Row className="overview-header">
          <Col md="5" className="mr-2 custom-md-5">
            <Col md="12" className="p-v-15 border-box shadow-sm rounded">
              <Row className="ht-100">
                <Col sm="6" className="padding-right-8">
                  <h2 className="only-competitor-head">Competitor Overview <HelpTextPopup parm={defaultProps} /></h2>
                  <CompetitorStore ref={this.compstorechild} />
                  {isLoading && (locationInfoData.compsCount === 0 || locationInfoData.compsCount === null) ? '' : locationInfoData.compsCount === 0 || locationInfoData.compsCount === null ? <div className="align-stores-btm"><p>Analyzing N/A</p></div> :
                    <div className="align-stores-btm"><p>Analyzing <Link to="#" onClick={() => this.getParams1(locationInfoData)}>{locationInfoData ? parseInt(locationInfoData.compsCount) > 1 ? locationInfoData.compsCount + ' stores' : locationInfoData.compsCount + ' store' : 'N/A'} </Link></p></div>
                  }
                </Col>
                {isPdfLoading === false || isLoading === false ?
                  <Col sm="6" className="pl-2 pr-2">
                    <h3>{locationInfoData && locationInfoData.storeName && locationInfoData.storeName !== null && locationInfoData.storeName !== undefined ? locationInfoData.storeName : 'Your Store'}</h3>
                    <div className={locationInfoData && locationInfoData.storeZoneCoverage ? locationInfoData.storeZoneCoverage.length > 24 ? "pd-btm-35" : "pd-btm-20" : "pd-btm-20"}><p className="m-0">{locationInfoData && locationInfoData.storeAddress1 && locationInfoData.storeAddress1 !== null && locationInfoData.storeAddress1 !== '' ? locationInfoData.storeAddress1 + ',' : ''} {locationInfoData.storeAddress2 ? locationInfoData.storeAddress2 + ', ' : ''} {locationInfoData && locationInfoData.storeCity ? locationInfoData.storeCity + ', ' : locationInfoData.searchType === 1 && (locationInfoData.storeCity === '' || locationInfoData.storeCity === null) && (locationInfoData.storeZipCode === '' || locationInfoData.storeZipCode === null) ? locationInfoData.latitude + ', ' + locationInfoData.longitude + ', ' : ''}{locationInfoData.storeState ? locationInfoData.storeState : ''} {locationInfoData ? locationInfoData.storeZipCode : 'N/A'}</p></div>
                    <div className="align-stores-btm"><p className="m-0 pt-1">Coverage: {locationInfoData ? locationInfoData.storeZoneCoverage : 'N/A'}</p></div>
                  </Col> : ''}
              </Row>
            </Col>
          </Col>
          <Col md="7" className="padding-left-0">
            <Col md="12" className="border-box shadow-sm rounded">
              <Row className="height-full">
                <Col xs="6" sm="6" md={locationInfoData.countryCode == "US" ? "3" : "4"} className="align-middle-div">
                  <h4>No. of Stores</h4>
                  <h5>{compOverviewData.overViewInfo ? compOverviewData.overViewInfo.compsCount : isLoading === false ? 'N/A' : ''}</h5>
                </Col>
                {locationInfoData.countryCode == "US" ?
                  <Col xs="6" sm="6" md="3" className="align-middle-div">
                    <h4>No. of REIT's</h4>
                    <h5>{compOverviewData.overViewInfo ? compOverviewData.overViewInfo.reits : isLoading === false ? 'N/A' : ''}</h5>
                  </Col>
                  : ''}
                <Col xs="6" sm="6" md={locationInfoData.countryCode == "US" ? "3" : "4"} className="align-middle-div">
                  <h4>No. of Multi-Ops</h4>
                  <h5>{compOverviewData.overViewInfo ? compOverviewData.overViewInfo.multiOps : isLoading === false ? 'N/A' : ''}</h5>
                </Col>
                <Col xs="6" sm="6" md={locationInfoData.countryCode == "US" ? "3" : "4"} className="align-middle-div">
                  <h4>No. of Single-Ops</h4>
                  <h5>{compOverviewData.overViewInfo ? compOverviewData.overViewInfo.singleOps : isLoading === false ? 'N/A' : ''}</h5>
                </Col>
              </Row>
            </Col>
          </Col>
        </Row>

        <div className="mt-3 is-it-store">
          <Col md="12" className="p-v-15 border-box shadow-sm rounded padding-bottom-0">
            <Row>
              <Col md="7">
                <div className="missed-competitor comp-over">
                  <MissingCompetitor className="list-item-text add-mar-comp" isShowModal={this.state.showModal} />
                </div>
              </Col>
              <Col md="5" className="float-right text-right competitor-nav">
                <Nav tabs className="d-inline-block line-height-change">
                  <NavItem className="grouped-btn d-inline-block">
                    <NavLink
                      className={classnames({ active: this.state.activeTab === '1' })}
                      onClick={() => { this.tabsChange('1'); }}>
                      <FontAwesomeIcon icon={faList} />
                    </NavLink>
                  </NavItem>
                  <NavItem className="grouped-btn d-inline-block">
                    <NavLink
                      className={classnames({ active: this.state.activeTab === '2' })}
                      onClick={() => { this.tabsChange('2'); }}
                    >
                      <LocationOn />
                    </NavLink>
                  </NavItem>
                </Nav>
                {this.state.activeTab !== "1" ? '' :
                  <Dropdown className="d-inline-block sort-by-option" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle caret>
                      {this.state.dropDownValue}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={(e) => this.handleClickOpen(e, "Store Name")}>Store Name</DropdownItem>
                      <DropdownItem onClick={(e) => this.handleClickOpen(e, "Year Built")}>Year Built</DropdownItem>
                      <DropdownItem onClick={(e) => this.handleClickOpen(e, "Total Square Footage")}>{(this.state.locationInfoData.countryCode === "DE" || this.state.locationInfoData.countryCode === "AT" || this.state.locationInfoData.countryCode === "CH") ? "Total Square Metre" : CONFIG.MeasurementLabel.toLowerCase() == 'total square feet' ? 'Total Square Footage' : CONFIG.MeasurementLabel}</DropdownItem>
                      <DropdownItem onClick={(e) => this.handleClickOpen(e, "Proximity")}>Proximity</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                }
              </Col>
              <Col>
                <div className="sqft-info">
                  <p><b>{(this.state.locationInfoData.countryCode === "DE" || this.state.locationInfoData.countryCode === "AT" || this.state.locationInfoData.countryCode === "CH") ? "Total Square Metre" : CONFIG.MeasurementLabel}</b> values displayed here are obtained from public sources, including city and county property records. When this information is unavailable, StorTrack uses mapping tools or internal models to estimate the size of the property - such properties have an asterisk (<span style={{ color: 'red' }}>*</span>) next to their {(this.state.locationInfoData.countryCode === "DE" || this.state.locationInfoData.countryCode === "AT" || this.state.locationInfoData.countryCode === "CH") ? "Total Square Metre" : CONFIG.MeasurementLabel} value.</p>
                </div>
                {/* <p className="sqft-disclaimer mb-1">* The {CONFIG.MeasurementLabel} values are obtained from publicly available sources. In instances where this information is unavailable, our team has used different methods to calculate the size of the property.</p> */}
              </Col>
            </Row>
            {/* List view grid */}
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Row className="only-competitor">
                  <Table className="m-0 legend-box">
                    <tbody>
                      <tr>
                        <td><FontAwesomeIcon icon={faCheck} className="green-clr" /> Pricing available for this unit type</td>
                        <td><FontAwesomeIcon icon={faTimes} className="red-clr" /> Pricing not available for this unit type</td>
                        <td><FontAwesomeIcon icon={faEyeSlash} /> Pricing previously available, but not currently advertised</td>
                        <td><FontAwesomeIcon icon={faStar} className="red-clr" /> Your Store</td>
                      </tr>
                    </tbody>
                  </Table>
                  <Col md="12" className="table-responsive comp-height">
                    {/* <InfiniteScroll pageStart={0} loadMore={()=> this.loadLazzyData()} hasMore={hasMoreData} useWindow={false} > */}
                    <div ref={this.myRef}>
                      <Table className="comp-view-grid">
                        <tbody>
                          <StoreStreetView ref={this.storeImageStreetView} />
                          {compOverviewData && storeData.length != 0 ? storeData.map((strdata) =>
                            <tr className="order-info-ele">
                              <td className="p-0">
                                <Table bordered className="mb-0 border-top-bottom-0">
                                  {/* <tbody>
                                  <tr key={strdata.storeID} className="store-id">
                                    <td colspan="4" className="border-0 first-td">
                                      <Row>
                                        <Col xs="2">
                                          <Link to="#" onClick={() => this.getStoreStreeView(strdata.latitude, strdata.longitude, strdata.storeName)} title="click here to view street view">
                                            <Avatar
                                              style={{ borderRadius: 0 }} className="unit-border-img">
                                              {strdata.StoreImage != '' ? <img className="Unit-Store-Img re-style-unit-store-img" src={strdata.storeImagePath} alt="No Image" alt="No image" onError={this.addDefaultSrc} /> : ''}
                                            </Avatar>
                                          </Link>
                                        </Col>
                                        <Col xs="10" className="pr-35 pl-1">
                                          <MarketProfile ref={this.child} />
                                          <h2 className="m-0">{strdata.isUserStore == 1 ? <FontAwesomeIcon icon={faStar} title={"Your Store"} /> : ''} <Link onClick={() => this.getParams(strdata.storeName, strdata.storeID)}>{strdata.storeName}</Link> {strdata.proximity != 0 ? <span>{strdata.proximity} {(CONFIG.RegionId == 2) || (CONFIG.RegionId == 4) ? 'kilometre' : 'mile'}{strdata.proximity <= 1 ? '' : 's'}</span> : ''}</h2>
                                          <p className="m-0 address-line">{strdata.storeAddress}</p>
                                        </Col>
                                      </Row>
                                    </td>
                                    <td colspan="3" className="border-0 sec-td">
                                      <div className="right-list"><Row><Col xs="7" className="pl-0"><label className="m-0">{CONFIG.MeasurementLabel}*</label></Col><Col xs="5" className="pl-0"><span className="storage-value">{strdata.squareFootage == "0" ? "N/A" : this.NumberFormat(strdata.squareFootage) + " " + CONFIG.MeasurementShortName}</span></Col></Row><div className="clear"></div></div>
                                      <div className="right-list"><Row><Col xs="7" className="pl-0"><label className="m-0">Opened</label></Col><Col xs="5" className="pl-0"><span className="storage-value">{strdata.opened == "0" ? "N/A" : strdata.opened}</span></Col></Row><div className="clear"></div></div>
                                    </td>
                                    <td colspan="3" className="border-0 third-td">
                                      <div className="right-list"><Row><Col xs="3" className="pl-0"><label className="m-0">Owned by</label></Col><Col xs="9" className="pl-0"><span className="storage-value">{strdata.ownedBy}</span></Col></Row><div className="clear"></div></div>
                                      <div className="right-list"><Row><Col xs="3" className="pl-0"><label className="m-0">Operated by</label></Col><Col xs="9" className="pl-0"><span className="storage-value">{strdata.operatedBy}</span></Col></Row><div className="clear"></div></div>
                                    </td>
                                    <td colspan="1" className="border-0 fourth-td">
                                      <div className="right-list"><label className="m-0">Price Volatility</label>{strdata.priceChangesPercent != null ? <span className="storage-value ml-1">{strdata.priceChangesPercent}% </span> : <span className="storage-value ml-1">N/A</span>}<div className="clear"></div></div>
                                      <h3 className="m-0 d-block last-days">Last 30 days</h3>
                                    </td>
                                  </tr>
                                </tbody> */}
                                  <tbody>
                                    <tr key={strdata.storeID} className="store-id">
                                      <td colspan="3" className="border-0 first-td">
                                        <Col xs="12" className="pr-35 pl-1">
                                          {/* <MarketProfile ref={this.child} /> */}
                                          <h2 className="m-0 remove-hyper">{strdata.isUserStore == 1 ? <FontAwesomeIcon icon={faStar} title={"Your Store"} /> : ''} <Link /*onClick={() => this.getParams(strdata.storeName, strdata.storeID)}*/>{strdata.storeName}</Link> {strdata.proximity != 0 ? <span>{strdata.proximity} mile{strdata.proximity <= 1 ? '' : 's'}</span> : ''}</h2>
                                          <p className="m-0 address-line">{strdata.storeAddress}</p>
                                        </Col>
                                      </td>
                                      <td colspan="3" className="border-0 sec-td">
                                        <div className="right-list"><Row><Col xs="6" className="pl-0"><label className="m-0">{(this.state.locationInfoData.countryCode === "DE" || this.state.locationInfoData.countryCode === "AT" || this.state.locationInfoData.countryCode === "CH") ? "Total Square Metre" : CONFIG.MeasurementLabel}</label></Col><Col xs="5" className="pl-0 pr-0"><span className="storage-value">{strdata.squareFootage == "0" ? "N/A" : this.NumberFormat(strdata.squareFootage) + " " + ((this.state.locationInfoData.countryCode === "DE" || this.state.locationInfoData.countryCode === "AT" || this.state.locationInfoData.countryCode === "CH") ? "sqm" : CONFIG.MeasurementShortName)}{(strdata.sqFtFlag == 2 && strdata.squareFootage !== "0") ? <sup style={{ color: 'red', fontSize: '13px' }}>*</sup> : ''}</span></Col></Row><div className="clear"></div></div>
                                        <div className="right-list"><Row><Col xs="6" className="pl-0"><label className="m-0">Opened</label></Col><Col xs="6" className="pl-0"><span className="storage-value">{strdata.opened == "0" ? "N/A" : strdata.opened}</span></Col></Row><div className="clear"></div></div>
                                      </td>
                                      <td colspan="3" className="border-0 third-td">
                                        <div className="right-list"><Row><Col xs="4" className="pl-0"><label className="m-0">Owned by</label></Col><Col xs="8" className="pl-0"><span className="storage-value">{strdata.ownedBy}</span></Col></Row><div className="clear"></div></div>
                                        <div className="right-list"><Row><Col xs="4" className="pl-0"><label className="m-0">Operated by</label></Col><Col xs="8" className="pl-0"><span className="storage-value">{strdata.operatedBy}</span></Col></Row><div className="clear"></div></div>
                                      </td>
                                      <td colspan="1" className="border-0 fourth-td">
                                        {/* <div className="right-list"><label className="m-0">Price Volatility</label>{strdata.priceChangesPercent != null ? <span className="storage-value ml-1">{strdata.priceChangesPercent}% </span> : <span className="storage-value ml-1">N/A</span>}<div className="clear"></div></div>
                                      <h3 className="m-0 d-block last-days">Last 30 days</h3> */}
                                        <div className="right-list"><label className="m-0" style={{ width: '85px' }}>Price Volatility</label>{strdata.priceChangesPercent !== null ? <span className="storage-value ml-1">{strdata.priceChangesPercent}%</span> : <span className="storage-value ml-1">N/A</span>}<div className="clear"></div>
                                          <h3 class="m-0 d-block last-days">Last 30 days</h3></div>
                                        <div className="right-list">
                                          <label className="m-0" style={{ width: '85px' }}>Last checked date</label>{strdata.lastVerified && strdata.lastVerified !== null ? <span className="storage-value ml-1">{moment(strdata.lastVerified).format('DD-MMM-YYYY')}</span> : <span className="storage-value ml-1">N/A</span>}
                                        </div>
                                        <div className="clear"></div>
                                      </td>
                                      <td colspan="1" className="border-0 fifth-td">
                                        <div className="line-normal"><a href="javascript:void(0)" className="street-view_see-web" onClick={() => this.getStoreStreeView(strdata.latitude, strdata.longitude, strdata.storeName)}>See street view</a></div>
                                        {/* {strdata && strdata.storeURL && strdata.storeURL != "" ? */}
                                        {/* <div className="line-normal"><Link rel="noopener noreferrer" onClick={this.historicalModalOpen.bind(this)} className="street-view_see-web">See historical data</Link></div> */}
                                        <div className="line-normal"><Link rel="noopener noreferrer" onClick={() => { this.historicModal(strdata.storeName, strdata.storeID) }} className="street-view_see-web">See historical data</Link></div>
                                        {strdata && strdata.storeURL && strdata.storeURL != "" ?
                                          <div className="line-normal"><a href={strdata.storeURL} target="_blank" className="street-view_see-web" >Go to store website</a></div>
                                          : ''}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                                <Table bordered className="mb-custom table-layout-fixed">
                                  <tbody>
                                    {/* <tr>
                                    {compOverviewData.unitData ? compOverviewData.unitData.map((untdata) =>
                                      strdata.storeID === untdata.storeID ?
                                        <td className="pl-0 pr-0 padding-top-0 pb-1">
                                          <p className="pr-2 pl-2 pb-2 border-bottom">{untdata.unitType}</p>
                                          <p className="pr-2 pl-2 mb-0">{untdata.value === 1 ? <FontAwesomeIcon icon={faCheck} className="green-clr" title="Pricing available for this unit type" /> : untdata.value === -1 ? <FontAwesomeIcon icon={faEyeSlash} title="Pricing previously available, but not currently advertised" /> : <FontAwesomeIcon icon={faTimes} className="red-clr" title="Pricing not available for this unit type" />}</p>
                                        </td>
                                        : ''
                                    ) : ''}
                                  </tr> */}
                                    <tr>
                                      {unitData.length > 0 && unitData.filter(untdata => untdata.storeID == strdata.storeID).map(untdata => {
                                        return (
                                          <td className="pl-0 pr-0 padding-top-0 pb-1">
                                            <p className="pr-2 pl-2 pb-2 border-bottom">{untdata.unitType}</p>
                                            <p className="pr-2 pl-2 mb-0">{untdata.value === 1 ? <FontAwesomeIcon icon={faCheck} className="green-clr" title="Rate available for this unit type" /> : untdata.value === -1 ? <FontAwesomeIcon icon={faEyeSlash} title="Rate previously available, but not currently advertised" /> : <FontAwesomeIcon icon={faTimes} className="red-clr" title="Rate not available for this unit type" />}</p>
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </tbody>
                                </Table>
                              </td>
                            </tr>
                          ) :
                            <tr>
                              <td className="text-center no-data">{isLoading === false ? 'There are no competitors available in this market' : ''}</td>
                            </tr>
                          }
                        </tbody>
                      </Table></div>
                    {/* </InfiniteScroll> */}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2" className="graph-view-tab">
                <Row className="">
                  <Col md="12">
                    <div className="map-view-height">
                      <div className='map-satellite-view' style={{ right: '30px' }}>
                        <button onClick={() => this.changeMapView(0)}>
                          <span className={satelliteView ? "map-satellite-opacity" : ""}>Map</span>
                        </button>
                        <button onClick={() => this.changeMapView(1)}>
                          <span className={satelliteView ? "" : "map-satellite-opacity"}>Satellite</span>
                        </button>
                      </div>
                      <MapGL
                        {...viewport}
                        ref={this.mapRef}
                        onViewportChange={this.handleViewportChange}
                        mapboxApiAccessToken={CONFIG.REACT_APP_MAPBOX_TOKEN}
                        mapStyle={satelliteView ? "mapbox://styles/mapbox/satellite-streets-v11" : "mapbox://styles/mapbox/streets-v11"}
                        onClick={this.onMarkerClick}
                        attributionControl={false}
                        onLoad={this.onLoadHomeMarker}
                      >
                        <NavigationControl className='zoom-plus-minus' showCompass={false} />
                        {/* {homeLatLng.latitude !== 0 && homeLatLng.longitude !== 0 &&
                          (<Marker {...homeLatLng} offsetLeft={-10} offsetTop={-12}>
                            <img src={homeIcon} alt="icon" />
                          </Marker>)} */}

                        {/* {homeLatLng.latitude !== 0 && homeLatLng.longitude !== 0 && */}
                        <Source
                          type="geojson"
                          data={{
                            'type': 'FeatureCollection',
                            'features': [{
                              'type': 'Feature',
                              'geometry': {
                                'type': 'Point',
                                'coordinates': [homeLatLng.longitude, homeLatLng.latitude]
                              }
                            }]
                          }}
                        >
                          <Layer
                            id="home-marker"
                            type="symbol"
                            layout={{
                              'icon-image': 'homeMarker',
                            }}
                          />
                        </Source>
                        <Source id="map-data" type='geojson' data={{ type: 'FeatureCollection', features: mapData }}>
                          <Layer {...layerStyle} />
                        </Source>

                        {this.state.showingInfoWindow && this.state.activeMarker !== '' ?
                          <Popup
                            {...popupInfoLatlng}
                            onClose={() => this.onMarkerClose()}
                          >
                            <table className="map-table" style={{ width: "100%" }}>
                              <tr>
                                <td width="70%">
                                  <b>{this.state.storeName} </b>
                                  <p> {this.state.address}<br />{this.state.address1}</p>
                                </td>
                                <td width="30%" style={{ textAlign: "center" }}>
                                  <img className="Unit-Store-Img" style={{ float: "none" }} src={this.state.imagePath} />
                                </td>
                              </tr>
                            </table>
                            <table>
                              <tr>
                                <td className="label-list">{((this.state.locationInfoData.countryCode === "DE" || this.state.locationInfoData.countryCode === "AT" || this.state.locationInfoData.countryCode === "CH") ? "Total Square Metre" : CONFIG.MeasurementLabel)} </td>
                                <td>{this.state.squareFootage}{totalSqFtFlag && this.state.squareFootage !== "N/A" ? <span style={{ color: 'red', fontSize: '13px' }}>*</span> : ""}</td>
                                {/* <td><sup>{this.state.squareFootage && this.state.squareFootage.replace(/(<([^>]+)>)/gi, "")}</sup></td> */}
                                {/* {console.log(this.state.squareFootage)} */}
                              </tr>
                              <tr>
                                <td className="label-list">Opened</td>
                                <td>{this.state.opened}</td>
                              </tr>
                              <tr>
                                <td className="label-list">Owned by</td>
                                <td>{this.state.ownedBy} </td>
                              </tr>
                              <tr>
                                <td className="label-list">Operated by</td>
                                <td>{this.state.operatedBy} </td>
                              </tr>
                              <tr>
                                <td className="label-list">Price Volatility</td>
                                <td> {this.state.priceChangesPercent} </td>
                              </tr>
                              <tr>
                                <td className="label-list">Units Offered</td>
                                <td style={{ width: "150px", lineheight: "18px" }}> {this.state.unitsOffered} </td>
                              </tr>
                            </table>
                          </Popup>
                          : ''}
                      </MapGL>
                    </div>
                  </Col>
                  <Col md="12" className="margin-2 map-btm-legend">
                    <Row className="ml-0 mb-2">
                      <div className="legend-block"><div className="maps-legend-orange rounded-circle"></div>Your Store</div>
                      <div className="legend-block"><div className="maps-legend-blue rounded-circle"></div>Competitor</div>
                    </Row>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
            {/* <Row>
              <Col md="12" className="mt-3 table-responsive">
                <Table className="comp-view-grid bordered" brder="1">
                  <TableBody>
                  {compOverviewData ? storeData.map((strdata) =>
                    <TableRow>
                      <TableCell className="p-0 table-responsive">
                        <Table>
                          <TableBody>
                            <TableRow key={strdata.storeID}>
                              <TableCell colspan="4">
                                <Row>
                                  <Col xs="2">
                                    <ListItemAvatar>
                                      <Avatar>
                                        <img src={`https://www.stortrack.com/storeimages/${strdata.storeID}.jpg`} />
                                      </Avatar>
                                    </ListItemAvatar>
                                  </Col>
                                  <Col xs="10">
                                    <h2 className="m-0 d-block">{strdata.storeName} <span>{strdata.proximity} miles</span></h2>
                                    <p className="m-0">{strdata.storeAddress}</p>
                                  </Col>
                                </Row>
                              </TableCell>
                              <TableCell colspan="2">
                                <h3 className="m-0 d-block">Total square feet <span>{strdata.squareFootage}.</span></h3>
                                <h3 className="m-0 d-block">Opened <span>{strdata.opened}</span></h3>
                              </TableCell>
                              <TableCell colspan="3">
                                <h3 className="m-0 d-block">Owned by <span>{strdata.ownedBy}</span></h3>
                                <h3 className="m-0 d-block">Operated by <span>{strdata.operatedBy}</span></h3>
                              </TableCell>
                              <TableCell colspan="2">
                                <h3 className="m-0 d-block">Price Volitality <span>{strdata.priceChangesPercent} %</span></h3>
                                <h3 className="m-0 d-block">Last 30 days</h3>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              {compOverviewData.unitData ? compOverviewData.unitData.map((untdata) =>
                              strdata.storeID === untdata.competitorID ? 
                              <TableCell>
                                <p>{untdata.units}</p>
                                <p>{untdata.value === 1 ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faTimes} />}</p>
                              </TableCell>
                              :''
                              ) : ''}
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                    ) : ''} 
                  </TableBody>
              </Table>
              </Col>
            </Row> */}
            {/* Map view grid */}
            {/* <Row className="mt-3">
              <Col md="12">
              <Gmaps
                  width={'100%'}
                  height={'300px'}
                  //lat={this.storeData[0].latitude}
                  //lng={this.storeData[0].longitude}
                  lat = {30.009415}
                  lng = {-90.15429}
                  zoom={10}
                  params={params}
                  onMapCreated={this.onMapCreated}>
                      {compOverviewData ? storeData.map((map) =>
                      <Marker
                          lat={map.latitude}
                          lng={map.longitude}
                          //lat={39.2075}
                          //lng={-75.5686}
                          onClick={() => this.onMarkerClick(map.storeID,map.storeName,map.storeAddress,map.squareFootage,map.opened,map.ownedBy,map.operatedBy,map.latitude,map.longitude,map.priceChangesPercent)}
                      />
                  ) : ''} 
                  {this.state.showingInfoWindow && this.state.activeMarker !='' ?
                    <InfoWindow
                    marker={this.state.activeMarker === undefined ? '' : this.state.activeMarker}
                    visible={this.state.showingInfoWindow}
                  //visible={false}
                    lat={this.state.lat}
                    lng={this.state.lng}
                    content={infoWindowContent}
                   //onCloseClick={this.onCloseClick}
                />
                  : ''}
              </Gmaps>
              </Col>
            </Row> */}
          </Col>
        </div>
        <Modal isOpen={hisData} toggle={this.cancelHisData.bind(this)} id="missing-Competitor-modal" className={this.props.className} size="lg">
          <ModalHeader Header toggle={this.cancelHisData.bind(this)} className="pb-1">Historical Marketing and Pricing Information</ModalHeader >
          <ModalBody className="misCompmodalBody">
            <Row className="margin-right-0">
              <Col>Market Details:</Col>
              <Col>Lat Checked:</Col>
            </Row>
            <Row>
              <div className="overflow-scroll-table br-0">
                <Paper className="bx-sh-0">
                  <Table className="table table-bordered custom-table">
                    <TableHead>
                      <TableRow className="table-header">
                        <TableCell>SPACE TYPE</TableCell>
                        <TableCell>SIZE</TableCell>
                        <TableCell>FLOOR</TableCell>
                        <TableCell align="center">FEATURES</TableCell>
                        <TableCell align="center">{CONFIG.RegionId === 3 ? "ADVERTISED ONLINE WEEKLY RATE" : "ADVERTISED ONLINE RATE"}</TableCell>
                        <TableCell align="center">LAST CHANGED</TableCell>
                        <TableCell align="center">{CONFIG.RegionId === 3 ? "ADVERTISED WALK-IN WEEKLY RATE" : "ADVERTISED WALK-IN RATE"}</TableCell>
                        <TableCell className="text-right">LAST CHANGED</TableCell>
                        <TableCell className="text-right">PROMOTION</TableCell>
                        <TableCell className="text-right">LAST CHANGED</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            </Row>
          </ModalBody>
        </Modal>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackOpen}
          className={this.state.snackClr + ' snackbar bg-color-primary custom-snackbar'}
          maxsnack={3}
          autoHideDuration={30000}
          onClose={this.snackHandleclose.bind(this)}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.snackHandleclose.bind(this)}
            >
              <CloseIcon />
            </IconButton>
          ]}
          message={<span id="message-id">{snackMSg}</span>}

        />
      </div>
    );
  }
}